import React, { useState } from 'react';
import { SketchPicker } from 'react-color';
import { Button } from '@mui/material';
import './EditChatCompo.css';

function EditChatCompo({ updateChatDesign, chatDesign = {}, user }) {
    const defaults = {
        chatTextColor: "#000",
        chatBgColor: "#fff",
        userTextColor: "#000",
        userBgColor: "#fff",
        fontSize: 16,
        fontFamily: "Arial"
    };

    const initialDesign = Object.keys(defaults).reduce((acc, key) => {
        acc[key] = chatDesign[key] || defaults[key];
        return acc;
    }, {});

    const [design, setDesign] = useState(initialDesign);

    const handleColorChange = (name, color) => {
        setDesign(prev => ({ ...prev, [name]: color.hex }));
    };

    const handleSave = () => {
        updateChatDesign(design, user);
    };
    

    const resetToDefault = () => {
        setDesign({
            chatTextColor: "#000",
            chatBgColor: "#fff",
            userTextColor: "#000",
            userBgColor: "#fff",
            fontSize: 16,
            fontFamily: "Arial",
        });
    };

    
    

    return (
        <div className="editor-container" style={{display: 'flex', flexDirection: 'column', alignItems: 'center', padding: '50px', gap: '50px'}}>
            <h2 style={{fontSize: '2rem'}}>Welcome to the editor 🎨</h2>

            <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-around', width: '100%', flexWrap: 'wrap'}}>
                <div>
                    Chatbot Text Color:
                    <SketchPicker 
                        color={design.chatTextColor} 
                        onChange={(color) => handleColorChange('chatTextColor', color)}
                    />

                </div>

                <div>
                    Chatbot Background Color:
                    <SketchPicker color={design.chatBgColor} onChange={(color) => handleColorChange('chatBgColor', color)} />
                </div>

                <div>
                    User Text Color:
                    <SketchPicker color={design.userTextColor} onChange={(color) => handleColorChange('userTextColor', color)} />
                </div>

                <div>
                    Header Background Color:
                    <SketchPicker color={design.headerBgColor} onChange={(color) => handleColorChange('headerBgColor', color)} />
                </div>

            </div>
            
            <div style={{ marginTop: '20px', display: 'flex', flexDirection: 'row', gap: '20px'}}>
                <Button variant="contained" color="primary" onClick={handleSave} style={{ marginRight: '10px'}}>Save Changes</Button>
                <Button variant="contained" color="secondary" onClick={resetToDefault}>Reset to Default</Button>
            </div>
        </div>
    );
}

export default EditChatCompo;
